<section class="bg-white pb-7">
  <div class="centered-with-padding px-2.5 pb-5 pt-2.5 desk:py-0">
    <div class="-mt-px mr-[-10px] flex h-[50px] justify-end desk:m-0 desk:items-center">
      <app-svg (click)="onClose()" [width]="16" class="cursor-pointer" src="assets/icons/close.svg" />
    </div>
    @if (data.title; as title) {
      <div class="desk:mt-20">
        <app-title [title]="title" class="text-balance text-center supports-[text-wrap:pretty]:text-pretty" size="h1" />
      </div>
    }
    @if (data.subtitle; as subtitle) {
      <p class="pt-4 text-center">{{ subtitle }}</p>
    }
    <div class="flex flex-col gap-y-5 desk:mt-20 desk:flex-row desk:justify-center desk:gap-6">
      @let store = storeSelected();
      @let slot = slotSelected();
      @if (store && slot) {
        <div class="mt-9 desk:mt-0 desk:w-[528px]">
          <app-appointment-details [confirmed]="true" [fullHeight]="true" [slotSelected]="slot" [storeSelected]="store">
            <div
              (clickOutside)="isCalendarMenuOpen.set(false)"
              (keydown.escape)="isCalendarMenuOpen.set(false)"
              class="relative">
              <app-button
                (onButtonClick)="isCalendarMenuOpen.set(!isCalendarMenuOpen())"
                [label]="'COMPONENT.CONFIRMATION-RDV-ESPACE-CLIENT.ADD_TO_CALENDAR' | translate"
                theme="WHITE" />
              @if (isCalendarMenuOpen() && calendar(); as calendar) {
                <ul
                  class="drop-shadow-custom absolute left-0 top-full z-10 mt-2 flex w-max flex-col rounded-xl bg-white py-2 text-[14px]">
                  <li>
                    <button (click)="downloadIcs(calendar.event)" class="flex w-full px-5 py-2 hover:bg-gray-light">
                      Apple
                    </button>
                  </li>
                  <li>
                    <a
                      (click)="isCalendarMenuOpen.set(false)"
                      [href]="calendar.googleUrl"
                      class="flex px-5 py-2 hover:bg-gray-light"
                      rel="noopener noreferrer"
                      target="_blank">
                      Google
                    </a>
                  </li>
                  <li>
                    <a
                      (click)="isCalendarMenuOpen.set(false)"
                      [href]="calendar.outlookUrl"
                      class="flex px-5 py-2 hover:bg-gray-light"
                      rel="noopener noreferrer"
                      target="_blank">
                      Outlook.com
                    </a>
                  </li>
                </ul>
              }
            </div>
          </app-appointment-details>
        </div>
      }
      @if (isLoginAvailable) {
        <div class="flex flex-col gap-y-4 rounded-xl bg-gray-light p-5 desk:w-[528px] desk:p-7">
          <h2 class="font-title text-[25px]">
            {{ "COMPONENT.CONFIRMATION-RDV-ESPACE-CLIENT.IMPEDIMENT_TITLE" | translate }}
          </h2>
          <p>{{ "COMPONENT.CONFIRMATION-RDV-ESPACE-CLIENT.IMPEDIMENT_TEXT" | translate }}</p>
          @switch (accountState()) {
            @case ("guest") {
              <div class="flex flex-col items-start gap-y-4">
                <app-button
                  (onButtonClick)="login(true)"
                  [label]="'COMPONENT.CONFIRMATION-RDV-ESPACE-CLIENT.CREATE_ACCOUNT' | translate" />
                <app-button
                  (onButtonClick)="login(false)"
                  [label]="'COMPONENT.CONFIRMATION-RDV-ESPACE-CLIENT.LOGIN' | translate"
                  theme="WHITE" />
              </div>
            }
            @case ("member") {
              <div>
                <app-button
                  [label]="'COMPONENT.CONFIRMATION-RDV-ESPACE-CLIENT.MY_ACCOUNT' | translate"
                  [url]="espaceClientUrl" />
              </div>
            }
          }
        </div>
      }
    </div>
  </div>
</section>
